import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralIntegrationInfoComponent } from './general-integration-info.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    GeneralIntegrationInfoComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    GeneralIntegrationInfoComponent
  ]
})
export class GeneralIntegrationInfoModule { }
